import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectJournalBusy, selectJournalRecent } from '../../../store/journal/journal.state';
import { map } from 'rxjs/operators';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActionActivityComponent } from '../action-activity/action-activity.component';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatIconButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-action-indicator',
    templateUrl: './action-indicator.component.html',
    styleUrls: ['./action-indicator.component.scss'],
    imports: [MatIconButton, IconComponent, AsyncPipe]
})
export class ActionIndicatorComponent implements OnInit {

    display$: Observable<boolean>;
    busy$: Observable<boolean>;

    constructor(private store: Store<AppState>, private bottomSheet: MatBottomSheet) {
        this.display$ = this.store.select(selectJournalRecent).pipe(
            map(list => list.length > 0)
        );
        this.busy$ = this.store.select(selectJournalBusy);
    }

    ngOnInit(): void {
    }

    open(): void {
        this.bottomSheet.open(ActionActivityComponent);
    }

}
